import { Box, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useRecordContext } from "react-admin";
import permissions from "app/permissions";
import SecuredComponent from "server/security/SecuredComponent";
import ItemFormDialog from "../dialogs/ItemFormDialog";
import DeleteItemDialog from "../dialogs/DeleteItemDialog";
import { useCollectionActions } from "./CollectionContext";

const RowActions = ({ collection }) => {
  const row = useRecordContext();
  const { items, saving, updateItemAt, removeItemAt } = useCollectionActions();

  if (!row) return null;

  // The dialog edits the stored item, not the decorated row, so the synthetic keys stay out of it.
  const item = items[row.rowIndex];

  return (
    <SecuredComponent permission={permissions.canUpdateCurriculums}>
      <Box sx={{ display: "flex", gap: 0.5, justifyContent: "flex-end" }}>
        <ItemFormDialog
          title={`Редакция · ${collection.singular}`}
          FormFields={collection.FormFields}
          record={item}
          onSave={data => updateItemAt(row.rowIndex, data)}
          dialogSize={collection.dialogSize}
          transform={collection.transform}
          formProps={{ rowIndex: row.rowIndex }}
          triggerButton={
            <IconButton
              color="primary"
              size="small"
              aria-label="Редакция"
              disabled={saving}
            >
              <EditIcon fontSize="small" />
            </IconButton>
          }
        />
        <DeleteItemDialog
          title={`Изтриване · ${collection.singular}`}
          itemLabel={collection.getItemLabel?.(item)}
          onConfirm={() => removeItemAt(row.rowIndex)}
          triggerButton={
            <IconButton
              color="error"
              size="small"
              aria-label="Изтриване"
              disabled={saving}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          }
        />
      </Box>
    </SecuredComponent>
  );
};

export default RowActions;
